// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: a cited passage (Agents Cite) as text. In a prompt it is a run of Markdown `> ` lines with an
// empty line under it, so the words after it are not read as part of the quote; on screen it is one
// row (CitedQuote) that opens to the whole passage.

/** A quote's lines as the Markdown quote that goes in the prompt. */
export function quoteMarkdown(text: string): string {
	return text
		.split('\n')
		.map((line) => `> ${line}`)
		.join('\n');
}

/** The quoted text of a `> ` line, or null when the line isn't one. */
export function quoteLine(line: string): string | null {
	const match = /^> (.*)$/.exec(line);
	return match ? match[1]! : null;
}

/** A quote in one row: its lines side by side. */
export function quoteRow(text: string): string {
	return text
		.split('\n')
		.map((line) => line.trim())
		.filter(Boolean)
		.join(' · ');
}
